import React, {useState} from 'react'

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';

function Settings() {
  const [collaboratorsCanManageShares, setCollaboratorsCanManageShares] = useState(false)


  return (
    <div>
      <Paper>
      <Box padding={5} margin={3}>


        <div>

          <FormControlLabel
            control={<Checkbox color="primary"/>}
            name="checkedH"
            onChange={() => setCollaboratorsCanManageShares(!collaboratorsCanManageShares)}
            label="Collaborators can manage shares"
            />
        </div>
        <br/>
        <br/>
        <br/>
        <Button variant="contained" color="primary">Update</Button>
            </Box>
      </Paper>
    </div>
  )
}

export default Settings
